<script setup lang="ts">
import { onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import { setSeoMetadata } from '@/utils/seo';
import { useLoginStore } from '@/stores/loginStore';
import { contentStore } from '@/stores/contentStore';

const lStore = useLoginStore();
const cStore = contentStore();
const route = useRoute();
const props = defineProps(['id'])
const cookieDeclined = localStorage.getItem('vue-cookie-accept-decline-undefined')=='decline';

watch(
    () => [cStore.title[props.id], cStore.content[props.id]],
    ([title, content]) => {
        if (title) {
            const language = String(route.params.lang ?? 'it').toLowerCase();
            setSeoMetadata({
                title,
                description: content || title,
                path: route.path,
                language
            });
        }
    },
    { immediate: true }
);

onMounted(async () => {
    try {
        await cStore.loadContent(props.id);
    } catch {
        ;
    }
});
watch(props, () => cStore.loadContent(props.id));

</script>

<template v-if="props.id">
    <div :id="cStore.title[props.id]" class="vContent" :class="{ cookiePolicyDenied: cookieDeclined }">
        <div class="adminTool flex w-full" v-if="lStore.isLoggedInAdmin && lStore.isAdminToolActive">
            <RouterLink :to="{ name: 'contentEditor', params: { content: props.id } }">
                <font-awesome-icon :icon="['fas', 'gear']" />
            </RouterLink>
        </div>
        <div v-html="cStore.content[props.id]" class="basis-full"></div>
    </div>
</template>

<style>
.vContent ul {
    list-style-type:  disc !important;
    list-style-position: outside;
    margin-left: 1em;
}

.cookiePolicyDenied iframe {
    display: none;
}
</style>
